// app/vaccancy/page.tsx
"use client";

import { motion } from "framer-motion";
import { MapPin, ArrowRight, Search } from "lucide-react";
import { useRouter } from "next/navigation";

// Clean color palette - Only Deep Teal Green and White
const colors = {
  primary: "#395750",
  primaryDark: "#2A423C",
  primaryLight: "#4B6B63",
  white: "#FFFFFF",
  whiteOff: "#F8F9FA",
  textDark: "#1A2E29",
};

const JobsBoard = () => {
  const router = useRouter();

  // Empty jobs array - no API calls
  const jobs: any[] = [];
  const loading = false;
  const error = null;

  return (
    <div className="min-h-screen pt-28" style={{ backgroundColor: `${colors.primary}05` }}>
      {/* Hero Section */}
      <div className="py-8" style={{ background: `linear-gradient(135deg, ${colors.primary}, ${colors.primaryLight})` }}>
        <div className="max-w-7xl mx-auto px-4 py-16 text-center">
          <h1 className="text-4xl font-bold text-white">Build Your Future With Yegna</h1>
          <p className="text-white/90 mt-4 text-lg">Explore career opportunities at Yegna Microfinance</p>
        </div>
      </div>

      {/* Search bar - hidden or disabled */}
      <div className="max-w-7xl mx-auto px-4 mt-4 flex justify-end">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2" size={16} style={{ color: colors.primaryLight }} />
          <input
            type="text"
            placeholder="Search jobs"
            className="px-3 py-1.5 text-sm rounded border pl-9 w-60 opacity-50 cursor-not-allowed"
            style={{
              borderColor: `${colors.primary}20`,
              backgroundColor: colors.white,
              color: colors.textDark
            }}
            disabled
            value=""
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid lg:grid-cols-4 gap-6">
          {/* Job Cards Section - Empty State */}
          <div className="lg:col-span-3 space-y-4">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="rounded-xl shadow-sm p-12 text-center"
              style={{ backgroundColor: colors.white }}
            >
              <div className="flex flex-col items-center justify-center py-12">
                {/* Empty state icon */}
                <div className="w-20 h-20 rounded-full flex items-center justify-center mb-4" style={{ backgroundColor: `${colors.primary}10` }}>
                  <svg 
                    className="w-10 h-10" 
                    style={{ color: colors.primary }}
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                
                <h3 className="text-xl font-bold mb-2" style={{ color: colors.textDark }}>
                  No Available Jobs
                </h3>
                <p className="text-gray-500 max-w-md">
                  There are currently no job vacancies posted. Please check back later for new opportunities at Yegna Microfinance.
                </p>
                
                <button
                  onClick={() => window.location.reload()}
                  className="mt-6 px-6 py-2 rounded-lg text-white transition-colors hover:opacity-90"
                  style={{ backgroundColor: colors.primary }}
                >
                  Refresh Page
                </button>
              </div>
            </motion.div>
          </div>

          {/* Sidebar - Empty Filters */}
          <div className="hidden lg:block">
            <div className="rounded-xl shadow-sm p-6" style={{ backgroundColor: colors.white }}>
              <h3 className="font-semibold mb-4" style={{ color: colors.textDark }}>Filters</h3>
              <div className="space-y-3 opacity-50">
                {["Full-time", "Part-time", "Remote", "Internship"].map((type) => (
                  <label key={type} className="flex items-center gap-2 text-sm cursor-not-allowed">
                    <input type="checkbox" disabled className="w-3.5 h-3.5 accent-[#395750]" />
                    <span style={{ color: colors.textDark }}>{type}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default JobsBoard;